import {
  apiAddAccountAffiliate,
  apiBuySimAffiliate,
  apiDetailSim,
  apiListAffiliate,
  apiShareSim,
} from "./urls"
import http from "../index"

// const addAccountAffiliate = body => http.post(apiAddAccountAffiliate, body)
const createLinkAffiliate = body => http.post(apiShareSim, body)
const detailSimAffiliate = id => http.get(apiDetailSim(id))
const listAffiliate = params => http.get(apiListAffiliate, { params })
const buySimAffiliate = (id,body) => http.put(apiBuySimAffiliate(id), body)
const AffiliateService = {
  createLinkAffiliate,
  detailSimAffiliate,
  listAffiliate,
  buySimAffiliate,
}
export default AffiliateService
